import {guardarDoc} from "../../Servicios/BD/guardarDoc";

export const crearEquipoPrimeraVez = async ({idUsuario}) => {


    let obj = {
        id: idUsuario,
        0: [],
        1: [],
        2: [],
        3: [],
        4: [],
        5: [],
    }

    let doxEquipo = await guardarDoc('equipos', obj)

    return doxEquipo


}